import React from "react";
import { toTitleCase } from "../../../lib/utils";

export default () => (
  <div>
    {toTitleCase(window.location.hostname)} makes limited use of cookies.
    “Cookies” help websites provide visitors with customized features. Our site
    may use cookies to deliver content specific to your interests, location, and
    for other purposes. You can choose whether to accept cookies by changing the
    settings of your Internet browser. You can reset your browser to refuse all
    cookies, or allow your browser to show you when a cookie is being sent. If
    you choose not to accept these cookies, your experience at our site may be
    diminished and some features may not work as intended.
  </div>
);
